import './toolbar.sass'

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from 'react-redux-i18n';

import NavbarToggle from 'controls/navbar-toggle/NavbarToggle';
import RecorderSelector from 'controls/recorder-selector/RecorderSelector';

import redirect from 'actions/redirect';

class Toolbar extends Component {
  handleChange(chosenRecorder) {
    let parsedUrl = new URL(window.location.href);
    let url = parsedUrl.pathname;

    if (url.indexOf('recorder-id') !== -1) {
      url = url.replace(/recorder-id\/[0-9]+/, 'recorder-id/' + chosenRecorder.id)
    } else {
      url = url.replace(/calibrations/, 'calibrations/recorder-id/' + chosenRecorder.id)
    }

    this.props.redirect(url);
  }

  handleCreate() {
    if (typeof parseInt(this.props.recorderId) === 'number') {
      this.props.redirect('/calibration/create/recorder-id/' + this.props.recorderId);
    }
  }

  render() {
    let isClear = true;
    if (this.props.recorderId) {
      isClear = false;
    }

    return (
      <nav className='calibrations-toolbar navbar navbar-default'>
        <div className='container-fluid'>
          <div className='navbar-header'>
            <NavbarToggle/>

            <a className='navbar-brand' href='#'>
            <Translate value='calibration.toolbar.title' />
            </a>
          </div>

          <div className='collapse navbar-collapse' id='bs-navbar-collapse'>
            <ul className='nav navbar-nav navbar-right'>
              <RecorderSelector
                chosenRecorderId={ this.props.recorderId }
                isClear={ isClear }
                handleChange={ this.handleChange.bind(this) }
              />
              <li><a href='#'
                className={ isClear ? 'calibrations-toolbar__is-hidden' : ''}
                onClick={ this.handleCreate.bind(this) }
              >
                <span className='glyphicon glyphicon-plus' aria-hidden='true'></span>
              </a></li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

Toolbar.propTypes = {
  recorderId: PropTypes.number,
  page:  PropTypes.number,
  pageSize: PropTypes.number,

  chosen: PropTypes.object.isRequired,
  redirect: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    chosen: state.recorders.chosen
  }
}

function mapDispatchToProps(dispatch) {
  return {
    redirect: bindActionCreators(redirect, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
